import React from "react";
import { Box, Typography, Paper } from "@mui/material";

const NotFound = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgcolor="#f5f5f7"
    >
      <Paper
        elevation={3}
        sx={{
          p: 5,
          maxWidth: 400,
          textAlign: "center",
          borderRadius: 4,
          animation: "fadeIn 0.5s ease-in-out",
        }}
      >
        <Typography variant="h3" fontWeight="bold" gutterBottom>
          404
        </Typography>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          Page Not Found
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={3}>
          The page you’re looking for doesn’t exist or you don’t have permission
          to view it.
        </Typography>
        {/* <Button
          variant="contained"
          color="primary"
          onClick={() => (window.location.href = "/")}
        >
          Go to Home
        </Button> */}
      </Paper>

      <style>{`
        @keyframes fadeIn {
          0% { opacity: 0; transform: translateY(20px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </Box>
  );
};

export default NotFound;
